export default __webpack_public_path__ + "static/media/task-complete.dedc5340.svg";